module.exports = __webpack_public_path__ + "static/media/LOGO  NARANJA Paneles Aislados y Arcos Steel arco 2019.b0cd6edb.png";